import { FormattedMessage } from 'react-intl';

import NewShipmentDrawer from '../../components/drawers/NewShipmentDrawer';
import StatementDrawerContent from './StatementDrawerContent';
import { useInvoiceStyles } from '../invoice/invoice.styles';

export default function StatementDrawer({ onClose, open }) {
  const { styles } = useInvoiceStyles();
  return (
    <NewShipmentDrawer
      className={styles.drawer}
      header={<FormattedMessage id="account.statement" />}
      open={open}
      onClose={onClose}
    >
      <StatementDrawerContent onClose={onClose} />
    </NewShipmentDrawer>
  );
}
